module.exports = __webpack_public_path__ + "static/media/instagramIcon.d3b6990f.svg";